import React from "react";
import { useMsal } from "@azure/msal-react";
import { AppBar, Toolbar, Typography, Button, Box } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";

const AuthLayout = ({ children }) => {
  const { instance, accounts } = useMsal();
  const currentUser = accounts[0];

  const handleLogout = () => {
    instance.logoutPopup({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Box sx={{ flexGrow: 1 }}>{children}</Box>
    </Box>
  );
};

export default AuthLayout;
